import { Component } from '@angular/core';

@Component({
    selector: 'app-skeleton-tasks',
    templateUrl: './skeleton-tasks.component.html',
    styleUrls: ['./skeleton-tasks.component.scss'],
    standalone: false
})
export class SkeletonTasksComponent {
  constructor() {}
}
